const progress = (value) => {
    document.getElementsByClassName('progress-bar')[0].style.width = `${value}%`;
}
let step, prevBtn, nextBtn, submitBtn, form, preloader, bodyElement, successDiv, stepCount;
$(document).ready(function () {
    if ($('#form-wrapper').length > 0) {
        step            = document.getElementsByClassName('step');
        stepCount       = step.length;    // dynamically set the step count
        prevBtn         = document.getElementById('prev-btn');
        nextBtn         = document.getElementById('next-btn');
        submitBtn       = document.getElementById('submit-btn');
        form            = document.getElementsByTagName('form')[0];
        preloader       = document.getElementById('preloader-wrapper');
        bodyElement     = document.querySelector('body');
        successDiv      = document.getElementById('success');
        let formState   = JSON.parse(localStorage.getItem('formState')) || {};
        const loadState = function () {
            $('#form-wrapper').find('input, textarea, select').each(function () {
                if (formState[this.id] === undefined) return;
                if (this.type === 'checkbox' || this.type === 'radio') {
                    this.checked = (formState[this.id]);
                } else if ($(this).hasClass('select2-form')) {
                    $(this).val(formState[this.id]).trigger('change');
                } else {
                    this.value = formState[this.id];
                }
            });
        }
        // Before and after step change, load state
        loadState();
        prevBtn.addEventListener('click', loadState);
        nextBtn.addEventListener('click', loadState);
        $('#form-wrapper').find('.select2-form').each(function () {
            const that    = this;
            const savedId = formState[this.id];
            if ($(this).hasClass('select2-hidden-accessible') && savedId !== undefined) {
                // Destroy select2 first
                $(this).select2('destroy');
            }
            $(this).select2({
                                //ajax: {} // Put your ajax call settings here
                            })
                .on('select2:select', function (event) {
                    formState[that.id] = $(this).val();
                    localStorage.setItem('formState', JSON.stringify(formState));
                });
            // Check if we have pre-selected options
            if ('undefined' !== typeof savedId && savedId) {
                // Preselect options
                const selectedOptions = {
                    id  : savedId,
                    text: formState[this.id + '_text'] // Assume that display text is saved with key = <original_key>_text
                };
                const option          = new Option(selectedOptions.text, selectedOptions.id, true, true);
                $(this).append(option).trigger('change');
            }
        });
        $('#form-wrapper').find('input, textarea, select').each(function () {
            if (formState[this.id] === undefined) return;
            if (this.type === 'checkbox' || this.type === 'radio') {
                this.checked = (formState[this.id]);
            } else {
                this.value = formState[this.id];
            }
        });
        // Save form state
        $('#form-wrapper').find('input, textarea, select').each(function () {
            $(this).on('change', function () {
                if (this.type === 'checkbox' || this.type === 'radio') {
                    formState[this.id] = this.checked;
                } else if ($(this).hasClass('select2-form')) {
                    const selectedOption = $(this).select2('data');
                    if (selectedOption) {
                        formState[this.id]           = selectedOption[0].id;
                        formState[this.id + '_text'] = selectedOption[0].text; // Save display text
                    }
                } else {
                    formState[this.id] = this.value;
                }
                localStorage.setItem('formState', JSON.stringify(formState));
            });
        });
        if (typeof form !== 'undefined') {
            form.onsubmit = (e) => {
                let isValid = validateRequired(currentStep) && currentStep === (stepCount - 1);
                if (isValid) {
                    localStorage.removeItem('formState');  // clear formState key only
                } else {
                    e.preventDefault(); // prevent form submission if not valid
                }
                return isValid;
            }
        }
    }
});
let currentStep       = 0;
window.getCurrentStep = function () {
    console.log("Current step: " + currentStep.toString() + " / " + stepCount.toString());
};
$(document).ready(function () {
    if (step[currentStep]) {
        step[currentStep].classList.add('d-block');
        if (stepCount === 1) { // If only one step, show submit button immediately and hide next button
            prevBtn.classList.add('d-none');
            submitBtn.classList.remove('d-none');
            submitBtn.classList.add('d-inline-block');
            nextBtn.classList.remove('d-inline-block');
            nextBtn.classList.add('d-none');
        } else if (currentStep == 0) {
            prevBtn.classList.add('d-none');
            submitBtn.classList.add('d-none');
            nextBtn.classList.add('d-inline-block');
            nextBtn.classList.remove('d-none');
        }

        nextBtn.addEventListener('click', () => {
            let validate = validateRequired(currentStep);
            if (validate) {
                currentStep++;
                let previous_step = currentStep - 1;
                if ((currentStep > 0) && (currentStep < stepCount)) {
                    prevBtn.classList.remove('d-none');
                    prevBtn.classList.add('d-inline-block');
                    step[currentStep].classList.remove('d-none');
                    step[currentStep].classList.add('d-block');
                    step[previous_step].classList.remove('d-block');
                    step[previous_step].classList.add('d-none');
                    if (currentStep == stepCount - 1) {
                        submitBtn.classList.remove('d-none');
                        submitBtn.classList.add('d-inline-block');
                        nextBtn.classList.remove('d-inline-block');
                        nextBtn.classList.add('d-none');
                    }
                }
                progress((100 / stepCount) * currentStep);
            }
        });

        prevBtn.addEventListener('click', () => {
            if (currentStep > 0) {
                currentStep--;
                let previous_step = currentStep + 1;
                prevBtn.classList.remove('d-none');
                prevBtn.classList.add('d-inline-block');
                step[currentStep].classList.remove('d-none');
                step[currentStep].classList.add('d-block');
                step[previous_step].classList.remove('d-block');
                step[previous_step].classList.add('d-none');
                if (currentStep < stepCount - 1) {
                    submitBtn.classList.remove('d-inline-block');
                    submitBtn.classList.add('d-none');
                    nextBtn.classList.remove('d-none');
                    nextBtn.classList.add('d-inline-block');
                    prevBtn.classList.remove('d-none');
                    prevBtn.classList.add('d-inline-block');
                }
            }
            if (currentStep == 0) {
                prevBtn.classList.remove('d-inline-block');
                prevBtn.classList.add('d-none');
            }
            progress((100 / stepCount) * currentStep);
        });
    }
});
$('.required').on('click', function () {
    $(this).removeClass('is-valid').removeClass('is-invalid');
});
let $eventSelect = $('.select2-form');
$eventSelect.select2();
$('[type=radio]').on("change", function (event) {
    let condValue = $(event.currentTarget).val();
    let condName  = $(event.currentTarget).attr('name');

    $(form)
        .find('.visible-if')
        .each(function (i, k) {
            let condition = $(k).data('visibleif');
            if (condition.includes(condName)) {
                if (condition === condName + '=' + condValue) {
                    $(k).slideDown();
                } else {
                    $(k).slideUp();
                }
            }
        });
});

function validateRequired(currentStep) {
    let inputs = $(step[currentStep]).find('.required');
    if (inputs.length === 0) {
        return true;
    }
    let invalidCount = 0;
    $(step[currentStep])
        .find('.required')
        .each(function (i, k) {
            if ($(k).is('input[type=text],textarea')) {
                $(k).removeClass('is-invalid').removeClass('is-valid');
                if ($(k).val().length === 0 || $(k).val().length < 3 || $(k).val() === null) {
                    $(k).addClass('is-invalid')
                    invalidCount++;
                } else {
                    $(k).addClass('is-valid')
                }
            }
            if ($(k).is('input[type=checkbox],input[type=radio]')) {
                if ($(k).is(':checked')) {
                    $(k).addClass('is-valid')
                } else {
                    $(k).addClass('is-invalid')
                    invalidCount++;
                }
            }
            if ($(k).is('select')) {
                if ($(k).val() !== null) {
                    $(k).addClass('is-valid')
                } else {
                    $(k).addClass('is-invalid')
                    invalidCount++;
                }
            }
        })
    return invalidCount === 0;
}

function validateEmail(input) {
    let validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (input.value.match(validRegex)) {
        alert("Valid email address!");
        return true;
    } else {
        alert("Invalid email address!");
        return false;
    }
}
